/* ============================================================
   PES Supply — Collection Filter Enhancement JS
   Provides:
   - Collapsible filter sections (Globo block collapse; native
     Shopify <details>/<summary> facets handle their own toggle)
   - Mobile filter drawer toggle (open/close with overlay)
   - Globo filter app integration (collapse + drawer-apply wiring)
   - Brand text injection in filter sidebar
   Brand text: "50,000+ SKUs from 169 authorized brands"

   NOTE (cleanup, Aug 2026): Sort dropdown, filter pill/chip styling,
   and subnav handling were removed from this file — they are now
   handled by pes-collection-ui-v4.js (loaded via ScriptTag), which
   also injects its own CSS and bypasses CDN caching. The custom
   "active filter chips" system (buildFilterChips/getActiveFilters/
   injectFilterBar/.pes-filter-bar/.pes-filter-chip) was removed as
   redundant — the theme's native facets.liquid already renders
   active filter chips via .active-facets / .active-facets__button.
   The sticky-sidebar scroll handler was removed as dead code: it
   only toggled a .pes-sidebar-active class that had no CSS rule
   anywhere (sticky positioning is handled purely via CSS on
   .cust-desktop-sortfilter). Globo integration, the mobile drawer,
   and collapsible sections are still required and were kept.
   ============================================================ */

(function() {
  'use strict';

  /* -------------------------------------------------------
     Configuration
     ------------------------------------------------------- */
  var PES_CONFIG = {
    green: '#11B67B',
    greenLight: '#11B67B',
    greenDark: '#0d8c5c',
    greenBg: '#f0fdf9',
    drawerWidth: 350,
    brandText: '50,000+ SKUs from 169 authorized brands'
  };

  /* -------------------------------------------------------
     Utility Functions
     ------------------------------------------------------- */

  function $(selector, context) {
    return (context || document).querySelector(selector);
  }

  function $all(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  function on(element, event, handler) {
    if (element) {
      element.addEventListener(event, handler);
    }
  }

  function createEl(tag, className, html) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (html !== undefined) el.innerHTML = html;
    return el;
  }

  function isCollectionPage() {
    return document.body.classList.contains('collection') ||
           document.querySelector('.cstm-collect-facets-container') !== null ||
           document.querySelector('#gf-products') !== null;
  }

  /* -------------------------------------------------------
     Collapsible Filter Sections
     (Globo filter app blocks only — native Shopify facets
     use <details>/<summary> which already toggles natively)
     ------------------------------------------------------- */

  function initCollapsibleSections() {
    var globoBlocks = $all('.gf-option-box .gf-block-title');
    globoBlocks.forEach(function(block) {
      if (block.hasAttribute('data-pes-initialized')) return;
      block.setAttribute('data-pes-initialized', 'true');
      block.style.cursor = 'pointer';

      on(block, 'click', function() {
        var content = block.nextElementSibling;
        if (content) {
          if (content.style.display === 'none') {
            content.style.display = '';
            block.classList.remove('pes-gf-collapsed');
          } else {
            content.style.display = 'none';
            block.classList.add('pes-gf-collapsed');
          }
        }
      });
    });
  }

  /* -------------------------------------------------------
     Mobile Filter Drawer
     ------------------------------------------------------- */

  function initMobileDrawer() {
    // Check if drawer already exists
    if ($('.pes-filter-drawer')) return;

    // Only create on mobile (but we create it regardless, it's hidden via CSS)
    var facetsContainer = $('.cust-desktop-sortfilter');
    if (!facetsContainer) return;

    // Create overlay
    var overlay = createEl('div', 'pes-filter-overlay');
    document.body.appendChild(overlay);

    // Create drawer
    var drawer = createEl('div', 'pes-filter-drawer');

    // Drawer header
    var header = createEl('div', 'pes-filter-drawer__header');
    var title = createEl('h2', 'pes-filter-drawer__title', 'Filters');
    var closeBtn = createEl('button', 'pes-filter-drawer__close', '&times;');
    closeBtn.setAttribute('type', 'button');
    closeBtn.setAttribute('aria-label', 'Close filters');
    header.appendChild(title);
    header.appendChild(closeBtn);

    // Drawer body (will hold a clone or the actual sidebar content)
    var body = createEl('div', 'pes-filter-drawer__body');

    // Drawer footer
    var footer = createEl('div', 'pes-filter-drawer__footer');
    var applyBtn = createEl('button', 'pes-filter-drawer__apply', 'Apply Filters');
    applyBtn.setAttribute('type', 'button');
    var clearBtn = createEl('button', 'pes-filter-drawer__clear', 'Clear All');
    clearBtn.setAttribute('type', 'button');
    footer.appendChild(clearBtn);
    footer.appendChild(applyBtn);

    drawer.appendChild(header);
    drawer.appendChild(body);
    drawer.appendChild(footer);
    document.body.appendChild(drawer);

    // Create mobile filter button
    var mobileBtn = createEl('button', 'pes-mobile-filter-btn');
    mobileBtn.setAttribute('type', 'button');
    var btnIcon = createEl('span', '', '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line></svg>');
    var btnText = createEl('span', '', 'Filters');
    var btnCount = createEl('span', 'pes-mobile-filter-btn__count');
    mobileBtn.appendChild(btnIcon);
    mobileBtn.appendChild(btnText);
    mobileBtn.appendChild(btnCount);

    // Insert mobile filter button before the collection grid
    var collectionContainer = $('.cstm-collect-facets-container');
    if (collectionContainer) {
      // Create a mobile filter bar
      var mobileBar = createEl('div', 'pes-mobile-filter-bar');
      mobileBar.appendChild(mobileBtn);

      // Also wrap the sort dropdown for mobile
      var sortForm = $('#FacetSortForm');
      if (sortForm) {
        var sortWrapper = createEl('div', 'pes-mobile-sort-wrapper');
        sortWrapper.appendChild(sortForm.cloneNode(true));
        mobileBar.appendChild(sortWrapper);
      }

      collectionContainer.parentNode.insertBefore(mobileBar, collectionContainer);
    }

    // Open drawer function
    function openDrawer() {
      // Move the actual facets content into the drawer
      var facetsContent = $('.cust-desktop-sortfilter');
      if (facetsContent) {
        // Clone the content into the drawer body
        body.innerHTML = '';
        var clone = facetsContent.cloneNode(true);
        clone.style.display = 'block';
        body.appendChild(clone);
      }

      drawer.classList.add('pes-filter-drawer--open');
      overlay.classList.add('pes-filter-overlay--visible');
      document.body.style.overflow = 'hidden';
    }

    // Close drawer function
    function closeDrawer() {
      drawer.classList.remove('pes-filter-drawer--open');
      overlay.classList.remove('pes-filter-overlay--visible');
      document.body.style.overflow = '';
    }

    // Event handlers
    on(mobileBtn, 'click', openDrawer);
    on(closeBtn, 'click', closeDrawer);
    on(overlay, 'click', closeDrawer);

    // Apply button - triggers the Globo filter apply or native form submit
    on(applyBtn, 'click', function() {
      var drawerFacets = body.querySelector('.cust-desktop-sortfilter');
      if (drawerFacets) {
        // Try to find and click any apply button in the Globo filter
        var globoApply = drawerFacets.querySelector('.gf-apply, .gf-apply-filter, button[type="submit"]');
        if (globoApply) {
          globoApply.click();
        } else {
          // Try native form submit
          var form = drawerFacets.querySelector('form');
          if (form) {
            form.submit();
          }
        }
      }
      closeDrawer();
    });

    // Clear all button
    on(clearBtn, 'click', function() {
      window.location.href = window.location.pathname;
    });

    // Close on escape key
    on(document, 'keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('pes-filter-drawer--open')) {
        closeDrawer();
      }
    });

    // Also handle the existing .filterBtn to open our drawer on mobile
    $all('.filterBtn').forEach(function(btn) {
      on(btn, 'click', function(e) {
        if (window.innerWidth <= 989) {
          // Let the existing Globo trigger work, but also open our drawer
          // Delay slightly to let Globo's own panel open first
          setTimeout(openDrawer, 100);
        }
      });
    });
  }

  /* -------------------------------------------------------
     Globo Filter App Integration
     Listen for Globo filter changes and re-run collapsible
     section init on dynamically injected content
     ------------------------------------------------------- */

  function initGloboIntegration() {
    // Watch for changes in the Globo filter container
    var globoContainer = $('#gf-products') || $('#gf-controls-container');
    if (!globoContainer) return;

    // Observe Globo's selected filter display
    var globoSelected = $('.gf-selected-items, .gf-refines');
    if (globoSelected) {
      var observer = new MutationObserver(function() {
        initCollapsibleSections();
      });
      observer.observe(globoSelected, { childList: true, subtree: true });
    }

    // Listen for URL changes (Globo may use AJAX)
    var lastUrl = window.location.href;
    setInterval(function() {
      if (window.location.href !== lastUrl) {
        lastUrl = window.location.href;
      }
    }, 1000);
  }

  /* -------------------------------------------------------
     Brand Text Injection
     ------------------------------------------------------- */

  function injectBrandText() {
    var sidebar = $('.cust-desktop-sortfilter');
    if (!sidebar) return;

    if (sidebar.querySelector('.pes-filter-brand-text')) return;

    var brandText = createEl('div', 'pes-filter-brand-text', PES_CONFIG.brandText);
    sidebar.appendChild(brandText);
  }

  /* -------------------------------------------------------
     Initialization
     ------------------------------------------------------- */

  function init() {
    if (!isCollectionPage()) return;

    // Initialize collapsible sections (Globo blocks)
    initCollapsibleSections();

    // Initialize mobile drawer
    initMobileDrawer();

    // Initialize Globo filter app integration
    initGloboIntegration();

    // Inject brand text
    injectBrandText();
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section reload (AJAX product loading)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 200);
  });

  // Re-initialize on DOM changes (for AJAX filter updates)
  var initTimer = null;
  var observer = new MutationObserver(function() {
    if (initTimer) clearTimeout(initTimer);
    initTimer = setTimeout(function() {
      initCollapsibleSections();
    }, 500);
  });

  // Start observing after page load
  window.addEventListener('load', function() {
    var productGrid = $('#ProductGridContainer') || $('#gf-products');
    if (productGrid) {
      observer.observe(productGrid, { childList: true, subtree: true });
    }
  });

})();
